import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-025bf2f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "time" }
const _hoisted_8 = { class: "footer" }
const _hoisted_9 = { class: "team-detail" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 他的团队 ", -1))
const _hoisted_11 = { class: "number" }
const _hoisted_12 = { class: "commission" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, " 累计返佣 ", -1))
const _hoisted_14 = { class: "price" }
const _hoisted_15 = {
  key: 1,
  class: "empty"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, " 当前暂无团员加入 ", -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.teamList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "g-card team-member",
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "avatar",
                    src: item.avatar
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.created), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.distributorCount), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, " ¥ " + _toDisplayString(item.commissionSum), 1)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
    ])
  ]))
}